export default {
    auth: {
      isLoading: false,
      error: false,
      isAuthenticated: false,
      user: {}
    }
  }